module.exports = __webpack_public_path__ + "static/media/call.b2770066.svg";